import t from"react";import r from"../Button/Button.js";const e=({url:e})=>t.createElement(r,{as:"a",className:"btn-primary btn btn-md btn-success w-full lg:max-w-[302px]",href:e},"Ver produto");export{e as default};
